import { forwardRef, useId } from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '../../utils/cn';

export const Select = forwardRef(
  ({ label, hint, error, options = [], placeholder, className, id, children, ...rest }, ref) => {
    const generatedId = useId();
    const inputId = id ?? generatedId;
    return (
      <div className="flex flex-col gap-1">
        {label && (
          <label htmlFor={inputId} className="text-sm font-medium text-fg">
            {label}
          </label>
        )}
        <div className="relative">
          <select
            id={inputId}
            ref={ref}
            className={cn(
              'h-10 w-full appearance-none rounded-lg border bg-bg pl-3 pr-9 text-sm text-fg',
              'focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent',
              'disabled:opacity-50 disabled:cursor-not-allowed',
              error ? 'border-status-error' : 'border-border',
              className,
            )}
            {...rest}
          >
            {placeholder && <option value="">{placeholder}</option>}
            {children ??
              options.map((opt) => (
                <option key={opt.value} value={opt.value} disabled={opt.disabled}>
                  {opt.label}
                </option>
              ))}
          </select>
          <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-fg-muted pointer-events-none" />
        </div>
        {error ? (
          <span className="text-xs text-status-error">{error}</span>
        ) : hint ? (
          <span className="text-xs text-fg-muted">{hint}</span>
        ) : null}
      </div>
    );
  },
);
Select.displayName = 'Select';